import React from "react";
import { getLogo, isCelltopHost } from "shared/components/DynamicLogo";
import "./style.css";

const Spinner = () => {
  // The overlay is dark, so always use the light-on-dark variant of the
  // brand that matches the hostname (CellTop on celltop.vip, PhonePlay
  // elsewhere). The PhonePlay logo is cropped by the CSS; the CellTop one has
  // different proportions and must be shown whole.
  const logo = getLogo(true);
  const logoClass = isCelltopHost()
    ? "spinner-logo spinner-logo--contain"
    : "spinner-logo";
  return (
    <div className="spinner-container">
      {/* iOS-style spinner */}
      <div className="ios-spinner">
        {[...Array(12)].map((_, index) => (
          <div 
            key={index} 
            className="ios-spinner-bar"
            style={{
              transform: `rotate(${index * 30}deg) translate(0, -20px)`,
              animationDelay: `${-1.2 + (index * 0.1)}s`
            }}
          />
        ))}
      </div>
      
      <img 
        src={logo} 
        className={logoClass}
        alt="Site Logo" 
        height='60' 
        style={{ marginTop: '5rem' }} 
      />
    </div>
  );
};
export default Spinner;
